{
  "accessControl.delete.confirmation": "<1>{{ value }}</1> er sletta frå Tilgangsstyring.",
  "accessControl": "Tilgangsstyring",
  "memberFee.add": "Legg til kontingent",
  "addFromResourceBase": "Legg til frå ressursbasen",
  "addNew": "Legg til ny",
  "addToBoard": "Legg til i styret",
  "addUser": "Legg til brukar",
  "clusterMemberAdvisor.title": "Rådgivere",
  "focusArea.details.subtitle": "Alle prosjekt og aktivitetar tilknytta til forkusområde er lista under.",
  "mainGoal.details.subtitle": "Alle prosjekt og aktivitetar tilknytta hovudmålet er lista under.",
  "projectCategory.details.description.1": "Alle prosjekt og aktivitetar tilknytta prosjektkategorien er lista under.",
  "memberFee.amount": "Beløp (kr)",
  "eMailInviteWillBeSent": "Ein e-post med invitasjon blir sendt til denne brukaren.",
  "projectCategory.delete.confirm": "Er du sikker på at du vil slette {{ name }}?",
  "accessControl.delete.modal.title": "Er du sikker på at du vil sletta desse brukarane?",
  "deleteInterestAreaMessage": "Er du sikker på at du vil slette dette interesseområdet?",
  "memberFee.delete.title": "Er du sikker på at du vil slette denne kontingenten?",
  "timeRate.delete.confirmation": "Er du sikker på at du vil slette denne timesatsen?",
  "timeRate.description": "Øverst visast beløpet for standard timesats. Denne timesatsen vil gjelde for alle kontaktene som finns i klynga - med mindre ein har definert ein eigendefinert timesats for kontakta (demonstrerast seinare i brukarveiledninga)",
  "clusterBoardMember.title": "Styringsgruppe",
  "changeRole": "Endre rolle",
  "changeRoleFor": "Endre rolle for",
  "chooseRole": "Velg rolle",
  "coreData": "Grunndata",
  "addUser.error": "Kunne ikkje opprette denne brukaren.",
  "interestArea.error.edit": "Kunne ikkje endre interesseområde. Prøv igjen.",
  "error.mainContact.update": "Kunne ikkje endre hovudkontakt. Vennlegst prøv igjen.",
  "error.interestArea.create": "Kunne ikkje lage nytt interesseområde. Vennlegst prøv igjen.",
  "timeRate.create.error": "Kunne ikke opprette timesats. Vennligst prøv igjen.",
  "error.interestArea.delete": "Kunne ikkje slette interesseområde. Vennlegst prøv igjen.",
  "interestArea.error.delete": "Kunne ikkje slette interesseområde. Prøv igjen.",
  "projectCategory.error.delete": "Kunne ikkje slette prosjektkategori. Vennlegst prøv igjen.",
  "accessControl.delete.error": "Kunne ikkje sletta brukarane, ver venleg og prøv igjen.",
  "timeRate.delete.error": "Kunne ikke slette timesats. Vennligst prøv igjen.",
  "interestArea.error.save": "Kunne ikkje lagre interesseområde. Prøv igjen.",
  "error.interestArea.update": "Kunne ikkje oppdatere interesseområde. Vennlegst prøv igjen.",
  "projectCategory.error.edit": "Kunne ikkje oppdatere prosjektkategori. Sjekk at same namn ikkje allereie eksisterer og prøv på nytt.",
  "timeRate.update.error": "Kunne ikke endre timesats. Vennligst prøv igjen.",
  "projectCategory.delete": "Slett prosjektkategori",
  "portalInvitation.modal.description": "Vil du sende portalinvitasjon til disse kontaktene?",
  "editDefaultTimeRate": "Endre standard timesats",
  "editInterestAreas": "Endre interesseområde",
  "memberFee.edit": "Endre medlemskontingent",
  "projectCategory.edit": "Endre prosjektkategori",
  "editTimeRate": "Endre timesats",
  "employees": "Ansatte",
  "external": "Ekstern",
  "focusArea.notFound": "Fokusområde ikkje funne",
  "memberFee.delete.description": "Dersom du sletter denne kontingenten vil alle medlemmar som er knytta til kontingenten miste sin kontingent.",
  "timeRate.delete.description": "Hvis du sletter denne satsen så vil alle kontakter som er knyttet til denne satsen bli knyttet til standard sats.",
  "interestAreas": "Interesseområder",
  "clusterManagement.title": "Ledelse",
  "memberFee": "Medlemskontingent",
  "mission": "Misjon",
  "memberFee.name": "Namn på kontingent",
  "memberFee.new": "Ny medlemskontingent",
  "memberFee.delete.noMembers": "Ingen medlemmar er knytta til denne kontingenten.",
  "otherTimeRates": "Andre timesatser",
  "clusterManagement.description": "Vennligst legg til alle kontaktpersoner som utgjør ledelsen.",
  "portalInvitation.success": "Portalinvitasjonar sendt!",
  "project": "prosjekt",
  "projectCategories": "Prosjektkategoriar",
  "projectCategory.details.title": "Prosjektkategorien sine prosjekt og aktivitetar",
  "projectCategory": "Prosjektkategori",
  "projectCategory.details.description.2": "Prosjektkategorien kan ikkje slettast hvis prosjekt brukar den.",
  "projectCategory.notFound": "Prosjektkategori ikkje funne",
  "project_plural": "prosjekt",
  "removeFromManagement": "Fjern frå ledelse",
  "searchByNameEmailOrRole": "Søk etter namn, e-post eller rolle",
  "selectRole": "Velg rolle",
  "sendInvite": "Send invitasjon",
  "sendPortalInvitation": "Send portalinvitasjon",
  "portalInvitation.pending": "Sender portalinvitasjonar...",
  "memberFee.description": "Sett opp et antall medlemskontingenter som passer til måten dere organiserer medlemmene. Du kan sette en medlemskontingent på hvert medlem eller sette et egendefinert beløp.",
  "focusArea.details.title": "Fokusområdets prosjekt og aktivitetar.",
  "mainGoal.details.title": "Hovudmålets prosjekt og aktivitetar",
  "memberFee.delete.members": "Det er {{ count }} medlemmar knytta til denne kontingengen.",
  "fieldRequired": "Dette feltet er påkrevd",
  "accessControl.delete.text": "Dette vil sletta <1>{{ value }}</1> frå Tilgangsstyring. Vedkommande vil mista tilgang til Flerbedriftsportalen. Du kan ikkje angre denne handlinga.",
  "timeRates": "Timesatsar",
  "memberFee.tips": "Tips: Legg til beløp i namnet på denne kontingenten for å få ei rask oversikt over namn og beløp når du knyttar medlemmane mot kontingentenø",
  "vision": "Visjon",
  "visionMission.title": "Visjon og misjon",
  "yourProfile.title": "Profilen din",
  "accessControl.invite.error": "Kunne ikkje invitere brukarar. Ver venleg og prøv igjen.",
  "accessControl.createUser.title.selectMethod": "Vel korleis du vil leggje til ny brukar",
  "accessControl.createUser.title.searchExistingContact": "Hent informasjon frå ein kontakt",
  "accessControl.createUser.title.createNewUser": "Legg til ny brukar",
  "accessControl.createUser.confirmation.text": "<1>{{ name }}</1> er lagd til.",
  "accessControl.createUser.create.error.message": "Kunne ikkje opprette brukar. Ver venleg og prøv igjen.",
  "accessControl.createUser.invite.error.message": "Kunne ikkje invitere brukar. Ver venleg og prøv igjen.",
  "accessControl.inviteUser.confirmation.text": "E-postar med invitasjon er sendt ut til desse brukarane.",
  "accessControl.deleteUsers.text": "Desse brukarane er sletta frå Tilgangsstyring.",
  "accessControl.delete.error.modal.title": "Orsak, vi klarer ikkje å slette desse brukarane",
  "accessControl.delete.error.modal.description": "Desse brukarane er diverre ikkje blitt sletta frå Tilgangsstyring",
  "accessControl.delete.error.modal.supportText": "Prøv gjerne å sjekke om dei allereie er sletta frå Tilgangsstyring, eller kontakt oss på <1>{{ email }}</1>",
  "accessControl.create.cluster.radio.label": "Har du ein registrert kontakt du ynskjer å gje tilgang til Flerbedriftsportalen?",
  "accessControl.create.cluster.radio.value.existing": "Ja, eg vil hente informasjonen frå ein kontakt i Ressursbasen",
  "accessControl.create.cluster.radio.value.new": "Nei, eg vil leggje til ein ny brukar",
  "accessControl.create.cluster.radio.error": "Du må velje minst éin måte å leggje til ny brukar",
  "accessControl.selectAccessType": "Vel tilgangstype",
  "accessControl.roles.internal.writeAccess": "Tilsett - skrivetilgang",
  "accessControl.roles.external.readAccess": "Ekstern - lesetilgang",
  "accessControl.roles.select.helpText": "Alle tilsette får skrivetilgang, men berre administrator kan leggje til nye brukarar. Eksterne brukarar får berre lesetilgang, og dei kan ikkje gjere endringar i portalen.",
  "accessControl.roles.select.label": "Tilgangstype",
  "accessControl.edit.modal.title.default": "Rediger brukarinformasjon",
  "accessControl.edit.modal.title.error": "Orsak, vi klarte ikkje å endre denne brukaren",
  "accessControl.edit.modal.confirmation.text": "Informasjonen til <1>{{ name }}</1> er oppdatert.",
  "accessControl.edit.modal.error.supportText": "Prøv gjerne å laste inn sida på nytt, og forsøk å endre kontakten på nytt, eller kontakt oss på <1>{{ email }}</1>",
  "accessControl.edit.modal.error.text": "Det oppstod ein feil ved oppdatering av <1>{{ name }}</1>. Ver venleg og prøv igjen.",
  "emailSettings": "E-postvarsler",
  "emailSettings.updateOk": "Innstillingane for e-postvarslar er oppdatert",
  "emailSettings.updateFailed": "Kunne ikkje oppdatere innstillingane for e-postvarslar.",
  "emailSettings.frequency": "Frekvens",
  "emailsettings.activity": "Aktivitet",
  "emailSettings.opportunities": "Nye henvendingar"
}
